import { NgModule } from '@angular/core';
import { AddressComponent } from './address/address.component';
import { BranchOperationComponent } from './branch-operation/branch-operation.component';
import { DocumentComponent } from './document/document.component';
import { EntityOwnerComponent } from './entity-owner/entity-owner.component';
import { NotesComponent } from './notes/notes.component';
import { OfficeHoursComponent } from './office-hours/office-hours.component';
import { SharedModule } from '@shared';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from '../license/license-date-format';
import { ApplicantInformationComponent } from './applicant-information/applicant-information.component';
import { EmployerComponent } from '../license/hemo-tech/employer/employer.component';
import { QuestionsComponent } from '../license/hemo-tech/question/question.component';
import { CertificationComponent } from '../license/hemo-tech/certification/certification.component';
import { OnCampusBuildingComponent } from './on-campus-building/on-campus-building.component';
import { SatelliteLocationComponent } from './satellite-location/satellite-location.component';
import { ComplaintComponent } from './compliance/complaint/complaint.component';
import { AffectedPersonComponent } from './compliance/affected-person/affected-person.component';
import { PublicDocumentComponent } from './public-document/public-document.component';
import { HospitalServiceLocationComponent } from './hospital-service-location/hospital-service-location.component';

const COMPONENTS = [
  AddressComponent,
  DocumentComponent,
  NotesComponent,
  EntityOwnerComponent,
  BranchOperationComponent,
  OfficeHoursComponent,
  ApplicantInformationComponent,
  EmployerComponent,
  QuestionsComponent,
  CertificationComponent,
  OnCampusBuildingComponent,
  SatelliteLocationComponent,
  ComplaintComponent,
  AffectedPersonComponent,
  PublicDocumentComponent,
  HospitalServiceLocationComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    SharedModule
  ],
  exports: [
    ...COMPONENTS
  ],
  providers: [
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER,
  ]
})
export class ReusableModule { }
